import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import {Loading, Message} from 'element-ui';

NProgress.configure({showSpinner: false})

const whiteList = ['/login', '/register']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next('/index')
      NProgress.done()
    } else {
      // store.dispatch('updatePageButton', to.name).then(() => {
      //   next();
      // })
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()      // 在免登录白名单，直接进入
    } else {
      next('/login')
      Message.error('登录失效，请重新登录')
      NProgress.done()
    }
  }
  next();
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js